import React, { useState } from "react";
import { CircularProgress } from "@mui/material";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import axios from "axios";
import Redeemloyalty from "../redeem-loyalty/redeem-loyalty";

const VerifyOTP = ({ handleEditRequestOtpForm, handleSendOtp, timer, loyaltyData }) => {
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const [loyaltyInfo, setLoyaltyInfo] = useState("");
  const [responseStatus, setResponseStatus] = useState({ code: null, message: "" });

  const localLoyaltyData = JSON.parse(localStorage.getItem("loyaltyData"));
  const otpLength = 6;

  const handleReSendOtp = () => {
    setOtp("");
    setResponseStatus({ code: "", message: "" });
    handleSendOtp();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setResponseStatus({ code: "", message: "" });
    const requestData = {
      mobile_number: loyaltyData.mobileNumber,
      store_url: loyaltyData.storeUrl,
      country_code: loyaltyData.countryCode,
      otp,
    };
    const source = axios.CancelToken.source();
    const responsePromise = axios.post(`${process.env.REACT_APP_PRODUCTION_URL}/api/ewards/customer-loyalty-verify`, requestData, { cancelToken: source.token });
    const timeoutPromise = new Promise((resolve, reject) => {
      setTimeout(() => {
        source.cancel("Request timed out");
        reject(new Error("Request timed out"));
      }, 20000);
    });
    try {
      const response = await Promise.race([responsePromise, timeoutPromise]);
      setLoading(false);
      setLoyaltyInfo(response.data.loyaltyInfo.response);
      setResponseStatus({ code: response.data.loyaltyInfo.status_code, message: "success" });
    } catch (error) {
      setLoading(false);
      if (error.message === "Request timed out") {
        setResponseStatus({ code: "", message: "Request timed out. Please try again later." });
      } else if (error.response) {
        const errorMessage = error.response.status === 500 ? "Internal Server Error. Please try again later." : error.response?.data?.resultMessage?.en || "Request failed";
        setResponseStatus({ code: error.response.status, message: errorMessage });
      } else {
        setResponseStatus({ code: "", message: "Network error. Please check your internet connection." });
      }
    }
  };

  const handleEditMobile = () => {
    setResponseStatus({ code: "", message: "" });
    setOtp("");
    handleEditRequestOtpForm();
  };

  const handleKeyDown = (event) => {
    if (event.keyCode === 38 || event.keyCode === 40) {
      event.preventDefault();
    }
  };

  // useEffect(() => {
  //   const storedLoyaltyInfo = localStorage.getItem("loyaltyInfo");
  //   if (storedLoyaltyInfo) {
  //     setResponseStatus({ code: 200, message: "" });
  //   }
  // }, []);

  return (
    <div>
      {responseStatus.code === 200 ? (
        <Redeemloyalty loyaltyData={localLoyaltyData} loyaltyInfo={loyaltyInfo} />
      ) : (
        <div>
          <h3 style={{ color: "#413C49", display: "inline-block" }}>Claim Your Loyalty Points</h3>
          <div style={{ position: "relative", height: "100%", display: "flex" }}>
            <button
              onClick={handleEditMobile}
              style={{
                height: "38px",
                width: "235px",
                cursor: "pointer",
                fontWeight: "bold",
                fontSize: "14px",
                backgroundColor: "#EEEAF4",
                border: "none",
                borderRadius: "5px",
                position: "relative",
              }}
            >{`${loyaltyData?.countryCode}  ${loyaltyData.mobileNumber}`}</button>
            <button
              onClick={handleEditMobile}
              style={{
                height: "38px",
                width: "40px",
                cursor: "pointer",
                backgroundColor: "var(--primary-color)",
                border: "none",
                borderRadius: "8px",
                position: "relative",
              }}
            >
              <BorderColorIcon
                className="edit-mobile-icon"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  fill: "var(--secondary-color)",
                }}
              />
            </button>
          </div>

          <form onSubmit={handleSubmit}>
            <div>
              <br />
              <input
                onKeyDown={handleKeyDown}
                type="number"
                pattern="[0-9]*"
                inputMode="numeric"
                style={{ fontFamily: "var(--font-family)" }}
                autoComplete="off"
                placeholder="Enter OTP"
                className="custom-textfield custom-otpfield"
                disabled={responseStatus.code === 200}
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                autoFocus={true}
              />
              <button style={{ height: "40px", cursor: otp.length !== otpLength ? "not-allowed" : "pointer" }} disabled={otp.length !== otpLength} className="custom-button verify-button" type="submit">
                Verify OTP
              </button>
            </div>
          </form>
          <p style={{ fontSize: "small" }}>
            Didn't receive an OTP?{" "}
            <span
              className={responseStatus.code === 200 || timer > 0 ? "disabled" : ""}
              onClick={responseStatus.code !== 200 && timer === 0 ? handleReSendOtp : null}
              style={{ cursor: responseStatus.code === 200 || timer > 0 ? "not-allowed" : "pointer", color: responseStatus.code === 200 || timer > 0 ? "gray" : "inherit" }}
            >
              <span style={{ fontWeight: "bold", textDecoration: "underline" }}>Resend OTP {timer > 0 ? `(${timer}s)` : ""}</span>
            </span>
          </p>
          {loading && <CircularProgress sx={{ color: "var(--primary-color)" }} />}
          {responseStatus.code !== 200 && <p className="error-msg">{responseStatus.message}</p>}
        </div>
      )}
    </div>
  );
};

export default VerifyOTP;
